import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Important for Angular features like ngIf, ngFor
import { ButtonModule } from 'primeng/button'; // Import PrimeNG ButtonModule
import { Router } from '@angular/router'; // To navigate back

@Component({
  selector: 'app-logs.component',
  standalone: true,
  imports: [CommonModule, ButtonModule], // Add ButtonModule here
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.scss' 
})
export class LogsComponent {
  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/']); // Navigate to the root or dashboard page
    // Or, if you want to go back to the previous page in history:
    // this.router.navigateByUrl(this.router.url); // Example to reload current or go to previous
    // history.back(); // Native browser back button
  }
}